import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import config from '../config.json';
import NavMenu from './NavMenu';

const apiUrl = config.apiUrl;
const Home = () => {
  const [loading, setLoading] = useState(true);
  const [overtimeData, setOvertimeData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [undertimeData, setUndertimeData] = useState([]);
  const [timeEntryData, setTimeEntryData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem('token'));

  const roles = JSON.parse(localStorage.getItem('Roles'));

  const userAccess = {
    hasView: roles?.includes('View') || false,
    hasAdmin: roles?.includes('Admin') || false,
    hasApprover: roles?.includes('Approver') || false,
    hasStandard: roles?.includes('Standard') || false,
    hasReviewer: roles?.includes('Reviewer') || false,
    };

  const { hasView, hasAdmin, hasStandard, hasApprover, hasReviewer } = userAccess;

  useEffect(() => {
    redirectToPath();
  }, []);

  const redirectToPath = () => {
    // Navigate to the report view path if the user is an admin
    if (hasAdmin) {
      navigate('/reportviews');
    }
    else if(hasStandard) {
      navigate('/employee-list');
    }
    else if (hasReviewer) {
      navigate('/reportviews');
    }
  };

  useEffect(() => {
    // Fetch overtime data when the component mounts
    fetchOvertimeData();
    fetchLeaveData();
    fetchUndertimeData();
    fetchTimeEntryData();
  }, []);
  const fetchOvertimeData = async () => {
    const token = localStorage.getItem('token');
    try {

      const response = await fetch(`${apiUrl}/Overtime/ForApproval`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setOvertimeData(data.Overtime || []);
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
      setSuccessMessage('');
    }
  };

  const fetchLeaveData = async () => {
    const token = localStorage.getItem('token');
    try {

      const response = await fetch(`${apiUrl}/Leave/ForApproval`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setLeaveData(data.Leave || []);
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
      setSuccessMessage('');
    }
  };

  const fetchUndertimeData = async () => {
    const token = localStorage.getItem('token');
    try {

      const response = await fetch(`${apiUrl}/Undertime/ForApproval`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setUndertimeData(data.Undertime || []);
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
      setSuccessMessage('');
    }
  };

  const fetchTimeEntryData = async () => {
    const token = localStorage.getItem('token');
    try {

      const response = await fetch(`${apiUrl}/TimeEntry/ForApproval`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTimeEntryData(data.TimeEntry || []);
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
      setSuccessMessage('');
    }
  };

  return (
    <div>
      {hasApprover ? (
        <>
          <h3>For Approval</h3>
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          {successMessage && <div className="alert alert-success">{successMessage}</div>}
          <p>Overtime: {overtimeData.length}</p>
          <p>Leave: {leaveData.length}</p>
          <p>Undertime: {undertimeData.length}</p>
          <p>Time Entries: {timeEntryData.length}</p>
        </>
      ) : (
        <div>
          <h3>No access!</h3>
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      )}
    </div>
  )
};

export default Home;
